import React, { useEffect } from 'react';
import './MinisPage.css';

const MinisPage: React.FC = () => {
  useEffect(() => {
    // Force the page to stay at the top
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <div className="minis-page">
      {/* Header Section */}
      <div className="minis-header">
        <div className="minis-header-content">
          <h1 className="minis-header-title">Minis</h1>
          <p className="minis-header-description">
            There are always mini opportunities to improve an experience without reinventing the wheel. With these mini projects, I've imagined improvements to the Spotify, iOS, and Venmo mobile app experiences.
          </p>
        </div>
        <div className="minis-header-image">
          <div className="minis-header-placeholder">
            <img 
              src="/spotify-mockup.png" 
              alt="Spotify Mockup" 
              className="minis-header-mockup"
            />
            <img 
              src="/notification-mockup.png" 
              alt="Notification Mockup" 
              className="minis-header-mockup"
            />
            <img 
              src="/venmo-mockup.png" 
              alt="Venmo Mockup" 
              className="minis-header-mockup"
            />
          </div>
        </div>
      </div>

      <div className="spotify-content">
        <div className="spotify-text">
          <h1 className="spotify-title">Spotify Friend Commonality</h1>
          <p className="spotify-description">
            Spotify has built a social network around music but there lacks a way to examine the interesection between friends' music tastes. This page lets users explore the music they share in common with a friend.
          </p>
        </div>
        <div className="spotify-image">
          <div className="placeholder">
            <div className="iphone-frame">
              <img 
                src="/iphone16pro.png" 
                alt="iPhone Frame" 
                className="iphone-bezel"
              />
              <div className="video-content">
                <video 
                  className="demo-video"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="/spotify-demo.MOV" type="video/quicktime" />
                  <source src="/spotify-demo.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* iOS Urgent Notification Section */}
      <div className="notification-content">
        <div className="notification-text">
          <h1 className="notification-title">iOS Urgent Notification</h1>
          <p className="notification-description">
          Some messages can't wait. While useful for urgent updates, this feature can also play an important safety role when someone needs to contact you and calling isn't possible.        </p>
        </div>
        <div className="notification-image">
          <div className="placeholder">
            <img 
              src="/notification-mockup.png" 
              alt="iOS Urgent Notification Mockup" 
              className="notification-mockup"
            />
          </div>
        </div>
      </div>
      
      {/* Venmo Payments Distribution Section */}
      <div className="venmo-content">
        <div className="venmo-text">
          <h1 className="venmo-title">Venmo Payments Distribution</h1>
          <p className="venmo-description">
            Similar to Spotify, Venmo has built a social network around money but there lacks a way to examine the interesection between friends' spending habits. This page lets users explore how their money is distributed amongst friends.
          </p>
        </div>
        <div className="venmo-image">
          <div className="placeholder">
            <div className="iphone-frame">
              <img 
                src="/iphone16pro.png" 
                alt="iPhone Frame" 
                className="iphone-bezel"
              />
              <div className="video-content">
                <video 
                  className="demo-video"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="/venmo-demo.mov" type="video/quicktime" />
                  <source src="/venmo-demo.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinisPage;
